'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('../constants');

var MembersUtil = {};

/**
 * @param {Object} invitee with emailAddress or email
 * @param {String} locusUrl
 * @param {Boolean} alertIfActive
 * @returns {Object} the format object
 */
MembersUtil.generateAddMemberOptions = function (invitee, locusUrl, alertIfActive) {
  return {
    invitee: invitee,
    locusUrl: locusUrl,
    alertIfActive: alertIfActive
  };
};

/**
 * @param {Array} memberIds
 * @param {String} locusUrl
 * @returns {Object} the format object
 */
MembersUtil.generateAdmitMemberOptions = function (memberIds, locusUrl) {
  return {
    locusUrl: locusUrl,
    memberIds: memberIds
  };
};

/**
 * @param {Object} options with {invitee: {emailAddress, email}, alertIfActive}
 * @returns {Object} with {invitees: [{address}], alertIfActive}
 */
MembersUtil.getAddMemberBody = function (options) {
  return {
    invitees: [{
      address: options.invitee.emailAddress || options.invitee.email
    }],
    alertIfActive: options.alertIfActive
  };
};

/**
 * @param {Object} options with {memberIds}
 * @returns {Object} admit with {memberIds}
 */
MembersUtil.getAdmitMemberRequestBody = function (options) {
  return {
    admit: { memberIds: options.memberIds }
  };
};

/**
 * @param {Object} format with {memberIds, locusUrl}
 * @returns {Object} the request parameters (method, uri, body) needed to make a admitMember request
 */
MembersUtil.getAdmitMemberRequestParams = function (format) {
  var body = MembersUtil.getAdmitMemberRequestBody(format);
  return {
    method: _constants.PUT,
    uri: format.locusUrl + '/' + _constants.CONTROLS,
    body: body
  };
};

/**
 * @param {Object} format with {invitee {emailAddress, email}, locusUrl, alertIfActive}
 * @returns {Object} the request parameters (method, uri, body) needed to make a addMember request
 */
MembersUtil.getAddMemberRequestParams = function (format) {
  var body = MembersUtil.getAddMemberBody(format);
  var requestParams = {
    method: _constants.PUT,
    uri: format.locusUrl,
    body: body
  };
  return requestParams;
};

exports.default = MembersUtil;
//# sourceMappingURL=util.js.map
